import React from "react";
import { svgDataUrl, identityFor } from "../lib/mapIdentity";

/**
 * Small inline identity badge — used anywhere a contact's name is
 * rendered (Contacts list, Family, Alerts, Command Center, Groups, etc.).
 * Never navigates — it's purely visual and cheap to render.
 */
export default function IdentityBadge({ contact, size = 22, className = "" }) {
  const { shape, color } = identityFor(contact);
  return (
    <img
      src={svgDataUrl(shape, color, 100)}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`shrink-0 inline-block ${className}`}
      draggable={false}
      data-testid={`identity-badge-${shape}-${color}`}
    />
  );
}
